import PptxGenJS from "pptxgenjs";
import {
  map,
  meanBy,
  pick,
  round,
  flatMap,
  take,
  orderBy,
  takeRight,
} from "lodash";
import {
  COLORS,
  getMediaContent,
  getScoreTableRows,
  TEXT_OPTIONS,
} from "../masters/components";
import { TemplateData } from "..";

const RIGHT_COLUMN_X = 7.75;
const LEFT_COLUMN_X = 0.52;

export const addTalentDashboardSlide = (
  pres: PptxGenJS,
  data: TemplateData
) => {
  const slide = pres.addSlide({ masterName: "SPLIT_LEFT_MASTER" });

  if (data.candidateName) {
    slide.addText(data.candidateName, {
      placeholder: "title",
      color: COLORS.BLUE_PRIMARY,
      bold: true,
      fontFace: "Arial",
    });
  }

  slide.addText("TALENT DASHBOARD", {
    ...TEXT_OPTIONS.caption,
    color: COLORS.BLUE_LIGHT,
    x: RIGHT_COLUMN_X,
    y: 0.52,
    bold: true,
  });

  slide.addText(
    [
      {
        text: "Title",
        options: {
          breakLine: true,
        },
      },
      {
        text: "Company Name",
      },
    ],
    {
      ...TEXT_OPTIONS.body,
      paraSpaceAfter: 3,
      x: LEFT_COLUMN_X,
      y: 1.12,
      w: 6.72,
      fontSize: 16,
    }
  );

  slide.addText(
    [
      {
        text: "Career experience",
        options: {
          ...TEXT_OPTIONS.caption,
          breakLine: true,
        },
      },
      {
        text: "20.. - Present    Add position title | Add company name",
        options: {
          ...TEXT_OPTIONS.body,
          fontSize: 12,
          italic: true,
          breakLine: true,
        },
      },
      {
        text: "Board Roles",
        options: {
          ...TEXT_OPTIONS.caption,
          breakLine: true,
        },
      },
      {
        text: "20.. - Present    Add position title | Add company name",
        options: {
          ...TEXT_OPTIONS.body,
          fontSize: 12,
          italic: true,
          breakLine: true,
        },
      },
      {
        text: "Education",
        options: {
          ...TEXT_OPTIONS.caption,
          breakLine: true,
        },
      },
      {
        text: "Add your education here",
        options: {
          ...TEXT_OPTIONS.body,
          fontSize: 12,
          italic: true,
          breakLine: true,
        },
      },
    ],
    {
      valign: "top",
      x: LEFT_COLUMN_X,
      y: 2.12,
      w: 6.82,
      h: 6.6,
      fontSize: 18,
    }
  );

  const getGroupScore = (rows: any[]) =>
    round(
      meanBy(
        flatMap(rows, (r) => r.evaluations),
        "evaluation"
      )
    );

  const evaluationRows = orderBy(
    flatMap(data.evaluationRows, (rows, groupTitle) =>
      map(rows, (row) => ({ ...row, groupTitle }))
    ),
    ["evaluation.score"],
    ["desc"]
  );

  const topScoreRows = take(evaluationRows, 3);

  const lowScoreRows = takeRight(evaluationRows, 3);

  const groupRows = [
    {
      groupTitle: "Executive Readiness",
      rows: map(
        pick(data.evaluationRows, ["Experience", "Leadership Span"]),
        (rows, groupTitle) => ({
          title: groupTitle,
          score: getGroupScore(rows || []),
        })
      ),
    },
    {
      groupTitle: "Executive Potential",
      rows: map(
        pick(data.evaluationRows, [
          "Growth Factors",
          "Growth Potential",
          "Potential Realization",
        ]),
        (rows, groupTitle) => ({
          title: groupTitle,
          score: getGroupScore(rows || []),
        })
      ),
    },
  ];

  const tableData = [
    [
      {
        text: "Target Role",
        options: {
          ...TEXT_OPTIONS.caption,
          align: "left",
          valign: "middle",
          colW: 2,
        },
      },
      {
        text: data.positionTitle,
        options: {
          ...TEXT_OPTIONS.body,
          align: "left",
          colspan: 4,
          valign: "middle",
        },
      },
    ],
    ...flatMap(groupRows, (group) => getScoreTableRows(group)),
    [
      {
        text: "Key insights",
        options: {
          ...TEXT_OPTIONS.caption,
          align: "left",
          valign: "middle",
          colW: 2,
          fill: COLORS.BLUE_TABLE,
        },
      },
      {
        text: "STRENGTHS",
        options: {
          ...TEXT_OPTIONS.columnTitle,
          align: "left",
          valign: "middle",
          fill: COLORS.BLUE_TABLE,
          colspan: 2,
        },
      },
      {
        text: "DEVELOPMENT OPPORTUNITIES",
        options: {
          ...TEXT_OPTIONS.columnTitle,
          align: "left",
          valign: "middle",
          fill: COLORS.BLUE_TABLE,
          colspan: 2,
        },
      },
    ],
    [
      "",
      {
        text: topScoreRows.map((row) => ({
          text: row.title,
        })),
        options: { ...TEXT_OPTIONS.bullet, colspan: 2 },
      },
      {
        text: lowScoreRows.map((row) => ({
          text: row.title,
        })),
        options: { ...TEXT_OPTIONS.bullet, colspan: 2 },
      },
    ],
    [
      {
        text: "Recommendations",
        options: {
          ...TEXT_OPTIONS.caption,
          align: "left",
          valign: "middle",
          colspan: 5,
          fill: COLORS.BLUE_TABLE,
        },
      },
    ],
    [
      {
        text: "Add your recommendations here",
        options: {
          placeholder: "body",
          italic: true,
          colspan: 5,
          valign: "middle",
        },
      },
    ],
  ];

  const tableOptions = {
    x: RIGHT_COLUMN_X,
    y: 1,
    w: "51%",
    h: 7.57,
    fontSize: 12,
    colspan: 5,
    rowH: 0.58,
    colW: [2, 1.53, 1.53, 1.53, 1.53],
  } as const;

  slide.addTable(tableData as any, tableOptions as any);
};
